// extracted by mini-css-extract-plugin
export default {"big":"IconButton-size_big__sOqFV","medium":"IconButton-size_medium__74d34","small":"IconButton-size_small__a8XST"};